var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNaEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 22,
    viewBox: "0 0 41 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5204 0V21.249H14.0965L4.08415 6.77518H3.90777V21.249H0.0584717V0H3.50313L13.5051 14.4842H13.6919V0H17.5204ZM24.4435 21.249H20.3347L27.8154 0H32.5674L40.0585 21.249H35.9498L30.2745 4.3577H30.1084L24.4435 21.249ZM24.5784 12.9175H35.7838V16.0093H24.5784V12.9175Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaEmoji);
export default __webpack_public_path__ + "static/media/NA-Emoji.609c74126822dc0a7c1d8eea2af35967.svg";
export { ForwardRef as ReactComponent };